// src/pages/SignupPage.js
import React, { useState } from 'react';
import { useNavigate  } from 'react-router-dom';
import { signup } from '../services/api';
import { Container, Title, Form, Input, Button } from '../styles/StyledComponents';
import Footer from '../components/Footer';

const SignupPage = () => {
  const [userData, setUserData] = useState({ username: '', email: '', password: '' });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signup(userData);
      navigate('/login');
    } catch (error) {
      console.error('Signup error:', error);
    }
  };

  return (
    <Container>
      <Title>Sign Up</Title>
      <Form onSubmit={handleSubmit}>
        <Input
          type="text"
          name="username"
          value={userData.username}
          onChange={handleChange}
          placeholder="Username"
          required
        />
        <Input
          type="email"
          name="email"
          value={userData.email}
          onChange={handleChange}
          placeholder="Email"
          required
        />
        <Input
          type="password"
          name="password"
          value={userData.password}
          onChange={handleChange}
          placeholder="Password"
          required
        />
        <Button type="submit">Sign Up</Button>
      </Form>
      <Footer />
    </Container>
  );
};

export default SignupPage;